import { I18nClobMap } from './i18n/i18n-clob-map';
import { Locale } from '@type/locale';
import { SystemParameter } from "@models/system-parameter";
import { BinaryFile } from "./binary-file";
import { I18nStringMap } from './i18n/i18n-string-map';

export class GeneralSettingId {
    generalSettingId: string;
}

export class GeneralSetting {
    generalSettingId: GeneralSettingId;
    address: I18nStringMap;
    constructor() {
        this.address = new I18nStringMap();
        let locale: Locale[] = ['en', 'zh_TW', 'zh_CN'];
        locale.forEach(locale => {
            this.address.put(locale, '');
        });
    }
}




export class Setting {
    systemParameters: SystemParameter[] = [];
    generalSetting: GeneralSetting;
    constructor() {
        this.systemParameters = [];
        this.generalSetting = new GeneralSetting();
    }
}


export class  SettingSearchingCriteria{
    code: string;   
    description: string;
    value: string;
}
